export default "__VITE_ASSET__BLWlKM$6__"